import { ApplicationRef, computed, Injectable, signal } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

import { concat, first, interval, Subscription } from 'rxjs';

import { EnvironmentService } from '../../services';

@Injectable({ providedIn: 'root' })
export class AppVersionWatchService {
  private readonly isVersionAvailableSignal = signal(false);

  private readonly isOpenPopupSignal = signal(false);

  private intervalChecksSub?: Subscription;
  private versionUpdatesSub?: Subscription;

  private readonly intervalMinutes = EnvironmentService.isDev ? 0.5 : 20; // dev - each 30 sec

  public showVersionPopupSgnl = computed(() => {
    return this.isVersionAvailableSignal() && this.isOpenPopupSignal();
  });

  constructor(
    private swUpdate: SwUpdate,
    private appRef: ApplicationRef,
  ) {}

  public closePopup(): void {
    this.versionUpdatesSub?.unsubscribe();
    this.intervalChecksSub?.unsubscribe();
    this.isOpenPopupSignal.set(false);
  }

  public startWatchUpdates(): void {
    if (this.swUpdate.isEnabled) {
      // Wait for the app to stabilize before starting the update check
      const appIsStable$ = this.appRef.isStable.pipe(
        first(isStable => isStable),
      );
      const interval$ = interval(this.intervalMinutes * 60 * 1000);
      const intervalChecks$ = concat(appIsStable$, interval$);

      this.intervalChecksSub = intervalChecks$.subscribe(() => {
        this.swUpdate
          .checkForUpdate()
          .then()
          .catch(error => {
            console.error('Failed to check for updates:', error);
          });
      });

      this.versionUpdatesSub = this.swUpdate.versionUpdates.subscribe(event => {
        if (event.type === 'VERSION_READY') {
          console.info('new version is available', event);
          this.isVersionAvailableSignal.set(true);
          this.isOpenPopupSignal.set(true);
        }
      });
    }
  }
}
